<template>
  <vs-popup :active.sync="isActive" :title="theReport ? (theReport.dateString + ' Z Raporu ' + theReport.branchName) : 'Z Raporu'" v-esc="escape" id="zReportPopup">
    <div class="con-example-prompt" v-if="theReport != null" id="zReportContent">
      <div class="z-report-slip">
        <!-- Header -->
        <div class="z-header text-center">
          <img :src="logo" class="z-logo" v-if="logo" style="max-width: 110px; margin-bottom: 5px;" />
          <h4 style="font-size: 14px; margin: 4px 0 0 0; font-weight: bold;">Z RAPORU</h4>
          <div class="dashed-line" style="margin: 8px 0;"></div>
          <div class="header-info">
            <div class="info-row"><span>Tarih:</span> <span>{{ theReport.dateString }}</span></div>
            <div class="info-row"><span>Kullanıcı:</span> <span>{{ theReport.userName || 'ALT KASA' }}</span></div>
            <div class="info-row"><span>Şube:</span> <span>{{ theReport.branchName }}</span></div>
          </div>
          <div class="dashed-line" style="margin: 8px 0;"></div>
        </div>

        <!-- 1. SATIŞLAR -->
        <div class="z-section">
          <div class="section-title">*** 1. Satış Özeti ***</div>
          <div class="info-row">
            <span>Sipariş Brüt Ciro:</span>
            <span>{{ $convertCurrency(completedSalesTotal + discountsTotal) }}</span>
          </div>
          <div class="info-row">
            <span>İndirim Tutarı:</span>
            <span>{{ $convertCurrency(discountsTotal) }}</span>
          </div>
          <div class="info-row">
            <span>Kampanya Tutarı:</span>
            <span>{{ $convertCurrency(0) }}</span>
          </div>
          <div class="info-row bold" style="border-top: 1px dashed #000;">
            <span style="padding-top: 5px;">Sipariş Net Ciro:</span>
            <span style="padding-top: 5px;">{{ $convertCurrency(completedSalesTotal) }}</span>
          </div>
          <div class="dashed-line"></div>
        </div>

        <!-- 2. GELİRLER -->
        <div class="z-section">
          <div class="section-title">*** 2. Ödeme Detayları ***</div>
          <table class="z-table">
            <thead>
              <tr>
                <th class="text-left">Ödeme Türü</th>
                <th class="text-right">Tutar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(pm, idx) in filteredPayments" :key="'pm'+idx">
                <td>{{ pm.name }}</td>
                <td class="text-right">{{ $convertCurrency(pm.value) }}</td>
              </tr>
              <tr v-if="filteredPayments.length === 0">
                <td colspan="2" class="text-center">Kayıt Bulunamadı</td>
              </tr>
              <tr v-if="filteredPayments.length > 0" class="bold" style="border-top: 1px dashed #000;">
                <td style="padding-top: 5px;">Toplam Net Gelir:</td>
                <td class="text-right" style="padding-top: 5px;">{{ $convertCurrency(filteredPaymentsTotal) }}</td>
              </tr>
            </tbody>
          </table>
          <div class="dashed-line"></div>
        </div>

        <!-- 3. GİDERLER & DÜŞÜMLER -->
        <div class="z-section">
          <div class="section-title">*** 3. Zaiyatlar ***</div>
          <div class="info-row"><span>Zayiatlar:</span> <span>{{ $convertCurrency(lossesTotal) }}</span></div>
          <div class="dashed-line"></div>
        </div>
    <!-- 4. KASA NAKİT HAREKETLERİ -->
        <div class="z-section">
          <div class="section-title">*** 4. Kasa Nakit Hareketleri ***</div>
          <div class="info-row"><span>Toplam Nakit Satış:</span> <span>{{ $convertCurrency(netNakitCiro) }}</span></div>
          <div class="info-row"><span>Dünden Devir:</span> <span>{{ $convertCurrency(theReport.openCountingAmount) }}</span></div>
          <div class="info-row"><span>Nakit Giriş Toplamı:</span> <span>{{ $convertCurrency(theReport.totalSafeCashEntriesPrice) }}</span></div>
          <div class="info-row"><span>Nakit Çıkış Toplamı:</span> <span>{{ $convertCurrency(theReport.totalExpense) }}</span></div>
          <div class="dashed-line"></div>
          <div class="info-row bold">
            <span>Gün Sonu Beklenen Nakit:</span>
            <span>{{ $convertCurrency(netNakitCiro + theReport.openCountingAmount + theReport.totalSafeCashEntriesPrice - theReport.totalExpense) }}</span>
          </div>
          <template v-if="theReport.type == 2 && theReport.id !== 0">
            <div class="info-row">
              <span>Gün Sonu Sayılan Nakit:</span>
              <span>{{ $convertCurrency(theReport.instantCashBalance) }}</span>
            </div>
            <div class="info-row bold">
              <span>Nakit Fark:</span>
              <span :class="theReport.instantCashBalance - (netNakitCiro + theReport.openCountingAmount + theReport.totalSafeCashEntriesPrice - theReport.totalExpense) < 0 ? 'text-danger' : (theReport.instantCashBalance - (netNakitCiro + theReport.openCountingAmount + theReport.totalSafeCashEntriesPrice - theReport.totalExpense) > 0 ? 'text-success' : '')">
                {{ theReport.instantCashBalance - (netNakitCiro + theReport.openCountingAmount + theReport.totalSafeCashEntriesPrice - theReport.totalExpense) > 0 ? '+' : '' }}{{ $convertCurrency(theReport.instantCashBalance - (netNakitCiro + theReport.openCountingAmount + theReport.totalSafeCashEntriesPrice - theReport.totalExpense)) }}
              </span>
            </div>
          </template>
          <div class="dashed-line"></div>
        </div>

        <!-- 5. GENEL BİLGİLER -->
        <div class="z-section">
          <div class="section-title">*** 5. Genel Bilgiler ***</div>
          <div class="info-row"><span>Sipariş Brüt Ciro:</span> <span>{{ $convertCurrency(completedSalesTotal + discountsTotal) }}</span></div>
          <div class="info-row"><span>Sipariş Net Ciro:</span> <span>{{ $convertCurrency(completedSalesTotal) }}</span></div>
          <div class="info-row"><span>Sipariş(Adisyon) Adedi:</span> <span>{{ siparisAdet }} AD</span></div>
          <div class="info-row"><span>Sipariş(Adisyon) Ort. Net Tutar:</span> <span>{{ $convertCurrency(siparisAdetBasinaOrtalamaTutar) }}</span></div>
          <div class="info-row"><span>Sipariş(Adisyon) İçi Ürün Adedi:</span> <span>{{ urunAdet }} AD</span></div>
          <div class="info-row"><span>Ürün Adet Başına Ort. Tutar:</span> <span>{{ $convertCurrency(urunAdetBasinaOrtalamaTutar) }}</span></div>
          
          <div class="dashed-line"></div>
          
          <div class="info-row"><span>İndirim Adedi:</span> <span>{{ totalDiscountCount }} AD</span></div>
          <div class="info-row"><span>İndirim Tutarı:</span> <span>{{ $convertCurrency(totalDiscountAmount) }}</span></div>
          
          <template v-for="(act, idx) in staffActionStats">
            <div class="info-row" :key="'act-qty-'+idx">
              <span>{{ act.nameLabel }}</span>
              <span>{{ act.quantity }} AD</span>
            </div>
            <div class="info-row" :key="'act-price-'+idx">
              <span>{{ act.priceLabel }}</span>
              <span>{{ $convertCurrency(act.totalAmount) }}</span>
            </div>
          </template>

          <div class="info-row"><span>Kişi Sayısı (Kuver):</span> <span>{{ kisiSayisi !== '' ? kisiSayisi : '-' }}</span></div>
          <div class="info-row"><span>Kişi Başı Ort. Hasılat:</span> <span>{{ kisiBasıOrtHasılat !== '' ? $convertCurrency(kisiBasıOrtHasılat) : '-' }}</span></div>
          
          <div class="dashed-line"></div>
        </div>

        <!-- 6. ÜRÜN SATIŞLARI (CİRO BAZLI) -->
        <div class="z-section">
          <div class="section-title">*** 6. Kategori Bazlı Satışlar (Tutar) ***</div>
          <table class="z-table">
            <thead>
              <tr>
                <th class="text-left">Grup</th>
                <th class="text-right">Tutar</th>
                <th class="text-right">Oran (%)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in categoryGirosByAmount" :key="'amt'+idx">
                <td>{{ item.typeValue }}</td>
                <td class="text-right">{{ $convertCurrency(item.amount) }}</td>
                <td class="text-right">{{ totalFilteredCategoryPrice > 0 ? ((item.amount / totalFilteredCategoryPrice) * 100).toFixed(1) : '0.0' }}%</td>
              </tr>
              <tr v-if="filteredCategoryGiros.length === 0">
                <td colspan="3" class="text-center">Kayıt Bulunamadı</td>
              </tr>
              <template v-if="filteredCategoryGiros.length > 0">
                <tr>
                  <td colspan="3"><div class="dashed-line" style="margin: 4px 0;"></div></td>
                </tr>
                <tr class="bold">
                  <td>TOPLAM</td>
                  <td class="text-right">{{ $convertCurrency(totalFilteredCategoryPrice) }}</td>
                  <td class="text-right">100.0%</td>
                </tr>
              </template>
            </tbody>
          </table>
          <div class="dashed-line"></div>
        </div>

        <!-- 7. ÜRÜN GRUBUNA GÖRE SATIŞLAR (ADET BAZLI) -->
        <div class="z-section">
          <div class="section-title">*** 7. Kategori Bazlı Satışlar (Adet) ***</div>
          <table class="z-table">
            <thead>
              <tr>
                <th class="text-left">Grup</th>
                <th class="text-right">Adet</th>
                <th class="text-right">Oran (%)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in categoryGirosByQuantity" :key="'qty'+idx">
                <td>{{ item.typeValue }}</td>
                <td class="text-right">{{ item.piece }}</td>
                <td class="text-right">{{ totalFilteredCategoryQuantity > 0 ? ((item.piece / totalFilteredCategoryQuantity) * 100).toFixed(1) : '0.0' }}%</td>
              </tr>
              <tr v-if="filteredCategoryGiros.length === 0">
                <td colspan="3" class="text-center">Kayıt Bulunamadı</td>
              </tr>
            </tbody>
          </table>
          <div class="dashed-line"></div>
        </div>

        <div class="z-footer">
          <h3 class="text-center">GENEL TOPLAM CİRO: {{ $convertCurrency((theReport.type == 2 && theReport.id !== 0) ? theReport.totalGiro : completedSalesTotal) }}</h3>
          <p class="text-center text-xsmall" v-if="theReport.id === 0">* Bu Rapor Gün Sonu Öncesi Canlı Verileri Göstermektedir (Açık Adisyonlar Dahil Edilmemiştir)</p>
          <p class="text-center text-xsmall" v-else>* Açık Adisyonlar Dahil Edilmemiştir</p>
        </div>
        
        <div class="text-center mt-4 hide-on-print">
          <vs-button @click="printReport" color="primary" icon-pack="feather" icon="icon-printer">Yazdır</vs-button>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import companyInfo from '../../../../model/constants/companyInfo';
import { 
  GetCategoryGiro, 
  GetCategoryGiroForDealer, 
  GetStaffActionReport, 
  GetTotalsOfSales, 
  GetTotalsOfSalesForDealer, 
  GetPaymentReport, 
  GetPaymentReportForDealer,
  getSumOfOrders,
  getSumOfOrdersForDealer,
  GetProductGiro,
  GetProductGiroForDealer
} from "@/api/Reports.js";
import { getLossList, getLossListForDealer } from "@/api/Loss.js";
import { getDiscountList, getDiscountListForDealer } from "@/api/Discount.js";

export default {
  data() {
    return {
      isActive: false,
      theReport: null,
      logo: companyInfo.logo,
      categoryGiroItems: [],
      staffActions: [],
      totalLossAmount: 0,
      totalDiscountAmount: 0,
      totalDiscountCount: 0,
      totalSalesAmount: 0,
      totalSalesCount: 0,
      totalCategoryPrice: 0,
      totalCategoryQuantity: 0,
      paymentReportItems: [],
      kuverCountFromProducts: 0
    }
  },
  watch: {
    isActive(val) {
      if (val) {
        // Reset old data to avoid showing previous report's data while loading
        this.categoryGiroItems = [];
        this.staffActions = [];
        this.totalLossAmount = 0;
        this.totalDiscountAmount = 0;
        this.totalDiscountCount = 0;
        this.totalSalesAmount = 0;
        this.totalSalesCount = 0;
        this.totalCategoryPrice = 0;
        this.totalCategoryQuantity = 0;
        this.paymentReportItems = [];
        this.kuverCountFromProducts = 0;

        if (this.theReport) {
          this.fetchCategoryGiro();
          this.fetchStaffActions();
          this.fetchLosses();
          this.fetchDiscounts();
          this.fetchSalesTotals();
          this.fetchPaymentReport();
          this.fetchProductGiro();
        }
      }
    }
  },
  computed: {
    // 1. Satışlar
    completedSalesTotal() {
      return this.totalSalesAmount;
    },

    // 2. Gelirler
    filteredPayments() {
      const excludeKeywords = ['indirim', 'iskonto', 'ikram', 'kampanya', 'düşüm', 'dusum'];
      return this.paymentReportItems.filter(pm => {
        if (!pm.name) return false;
        const normalized = pm.name
          .replace(/İ/g, 'i')
          .replace(/I/g, 'ı')
          .toLowerCase();
        return !excludeKeywords.some(keyword => {
          const kwNormalized = keyword.replace(/İ/g, 'i').replace(/I/g, 'ı').toLowerCase();
          return normalized.includes(kwNormalized) || pm.name.toLowerCase().includes(keyword);
        });
      });
    },
    filteredPaymentsTotal() {
      return this.filteredPayments.reduce((acc, curr) => acc + (curr.value || 0), 0);
    },

    // 3. Giderler & Düşümler
    lossesTotal() {
      return this.totalLossAmount;
    },
    discountsTotal() {
      return this.totalDiscountAmount;
    },
    netNakitCiro() {
      const cashPayment = this.paymentReportItems.find(pm => {
        if (!pm.name) return false;
        const name = pm.name.toLowerCase()
          .replace(/İ/g, 'i')
          .replace(/I/g, 'ı')
          .toLowerCase();
        return name === 'nakit';
      });
      return cashPayment ? (cashPayment.value || 0) : (this.theReport ? (this.theReport.totalCashGiro || 0) : 0);
    },

    // 4. Genel Bilgiler
    siparisAdet() {
      return this.totalSalesCount;
    },
    indirimsizNetToplamTutar() {
      return this.totalSalesAmount + this.totalDiscountAmount;
    },
    siparisAdetBasinaOrtalamaTutar() {
      return this.totalSalesCount > 0 ? (this.totalSalesAmount / this.totalSalesCount) : 0;
    },
    urunAdet() {
      return this.totalCategoryQuantity;
    },
    urunToplamTutar() {
      return this.totalCategoryPrice;
    },
    urunAdetBasinaOrtalamaTutar() {
      return this.totalCategoryQuantity > 0 ? (this.totalCategoryPrice / this.totalCategoryQuantity) : 0;
    },

    // Staff actions statistics
    ikramUrunAdet() {
      return this.staffActions.filter(x => x.actionType === 'Treat' || x.actionType === 'İkram').reduce((acc, x) => acc + x.quantity, 0);
    },
    ikramUrunTutar() {
      return this.staffActions.filter(x => x.actionType === 'Treat' || x.actionType === 'İkram').reduce((acc, x) => acc + x.totalPrice, 0);
    },
    iptalUrunAdet() {
      return this.staffActions.filter(x => x.actionType === 'Cancel' || x.actionType === 'İptal').reduce((acc, x) => acc + x.quantity, 0);
    },
    iptalUrunTutar() {
      return this.staffActions.filter(x => x.actionType === 'Cancel' || x.actionType === 'İptal').reduce((acc, x) => acc + x.totalPrice, 0);
    },
    ayrilanUrunAdet() {
      return this.staffActions.filter(x => x.actionType === 'Separation' || x.actionType === 'Ayırma').reduce((acc, x) => acc + x.quantity, 0);
    },
    ayrilanUrunTutar() {
      return this.staffActions.filter(x => x.actionType === 'Separation' || x.actionType === 'Ayırma').reduce((acc, x) => acc + x.totalPrice, 0);
    },
    yapilanIskontoAdet() {
      return this.staffActions.filter(x => x.actionType === 'Discount' || x.actionType === 'İndirim').reduce((acc, x) => acc + x.quantity, 0);
    },
    yapilanIskontoTutar() {
      return this.staffActions.filter(x => x.actionType === 'Discount' || x.actionType === 'İndirim').reduce((acc, x) => acc + x.totalPrice, 0);
    },
    kisiSayisi() {
      if (this.kuverCountFromProducts > 0) {
        return this.kuverCountFromProducts;
      }
      const kuverItem = this.categoryGiroItems.find(x => (x.typeValue || x.name || '').toLowerCase().includes('kuver'));
      return kuverItem ? (kuverItem.piece || kuverItem.quantity || 0) : '';
    },
    kisiBasıOrtHasılat() {
      const guests = this.kisiSayisi;
      return (guests !== '' && guests > 0) ? (this.totalSalesAmount / guests) : '';
    },
    adisyonBasıOrt() {
      const bills = this.theReport ? (this.theReport.totalBillCount || this.totalSalesCount || 0) : 0;
      return bills > 0 ? (this.totalSalesAmount / bills) : 0;
    },
    iptalEdilenAdisyonS() {
      const cancelActions = this.staffActions.filter(x => x.actionType === 'Cancel' || x.actionType === 'İptal');
      return new Set(cancelActions.map(x => x.orderId)).size;
    },
    iptalEdilenAdisyonT() {
      const cancelActions = this.staffActions.filter(x => x.actionType === 'Cancel' || x.actionType === 'İptal');
      return cancelActions.reduce((acc, x) => acc + x.totalPrice, 0);
    },
    birlestirilenAdisyonS() {
      const mergeActions = this.staffActions.filter(x => x.actionType === 'Merge' || x.actionType === 'Birleştirme');
      return new Set(mergeActions.map(x => x.orderId)).size;
    },
    birlestirilenAdisyonT() {
      const mergeActions = this.staffActions.filter(x => x.actionType === 'Merge' || x.actionType === 'Birleştirme');
      return mergeActions.reduce((acc, x) => acc + x.totalPrice, 0);
    },
    staffActionStats() {
      const actions = [
        { key: 'Treat', trKey: 'İkram', nameLabel: 'İkram Ürün Adedi:', priceLabel: 'İkram Ürün Tutarı:' },
        { key: 'Cancel', trKey: 'İptal', nameLabel: 'İptal Ürün Adedi:', priceLabel: 'İptal Ürün Tutarı:' },
        { key: 'Transfer', trKey: 'Transfer', nameLabel: 'Transfer Ürün Adedi:', priceLabel: 'Transfer Ürün Tutarı:' },
        { key: 'Merge', trKey: 'Birleştirme', nameLabel: 'Birleştirilen Ürün Adedi:', priceLabel: 'Birleştirilen Ürün Tutarı:' },
        { key: 'Separation', trKey: 'Ayırma', nameLabel: 'Ayrılan Ürün Adedi:', priceLabel: 'Ayrılan Ürün Tutarı:' },
        { key: 'ChangePaymentMethod', trKey: 'Ödeme Şekli Değişimi', nameLabel: 'Ödeme Şekli Değişen Ürün Adedi:', priceLabel: 'Ödeme Şekli Değişen Ürün Tutarı:' }
      ];

      return actions.map(act => {
        const filtered = this.staffActions.filter(x => x.actionType === act.key || x.actionType === act.trKey);
        const quantity = filtered.reduce((acc, x) => acc + x.quantity, 0);
        const totalAmount = filtered.reduce((acc, x) => acc + x.totalPrice, 0);
        return {
          ...act,
          quantity,
          totalAmount
        };
      }).filter(x => x.quantity > 0 || x.totalAmount > 0);
    },

    // Sorted Category lists for sections 5 and 6 (excluding 'Kampanya' which is not an actual product category)
    filteredCategoryGiros() {
      return this.categoryGiroItems.filter(item => {
        const val = (item.typeValue || item.name || '').toLowerCase()
          .replace(/İ/g, 'i').replace(/I/g, 'ı').trim();
        return val !== 'kampanya';
      });
    },
    categoryGirosByAmount() {
      return [...this.filteredCategoryGiros].sort((a, b) => b.amount - a.amount);
    },
    categoryGirosByQuantity() {
      return [...this.filteredCategoryGiros].sort((a, b) => b.piece - a.piece);
    },
    totalFilteredCategoryPrice() {
      return this.filteredCategoryGiros.reduce((acc, val) => acc + (val.amount || 0), 0);
    },
    totalFilteredCategoryQuantity() {
      return this.filteredCategoryGiros.reduce((acc, val) => acc + (val.piece || 0), 0);
    }
  },
  methods: {
    escape() {
      this.isActive = false;
    },
    getReportDates() {
      if (!this.theReport || !this.theReport.dateString) {
        return { startDate: new Date(), endDate: new Date() };
      }
      let dateParts = [];
      if (this.theReport.dateString.includes('.')) {
        dateParts = this.theReport.dateString.split('.');
      } else if (this.theReport.dateString.includes('/')) {
        dateParts = this.theReport.dateString.split('/');
      } else if (this.theReport.dateString.includes('-')) {
        dateParts = this.theReport.dateString.split('-');
      }

      let repDate = new Date();
      if (dateParts.length === 3) {
        repDate = new Date(dateParts[2], parseInt(dateParts[1]) - 1, dateParts[0]);
      }
      repDate.setHours(0, 0, 0, 0);

      let endD = new Date(repDate);
      endD.setHours(23, 59, 59, 999);

      return { startDate: repDate, endDate: endD };
    },
    getBranchPayload() {
      const branchId = this.theReport.branchId 
        || (this.theReport.branch ? this.theReport.branch.id : null) 
        || (this.$currentUser && this.$currentUser.branch ? this.$currentUser.branch.id : null)
        || (this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.branch ? this.$store.state.AppActiveUser.branch.id : null);
      return branchId ? { id: branchId } : null;
    },
    fetchCategoryGiro() {
      const dates = this.getReportDates();
      let payload = {
        branch: this.getBranchPayload(),
        dateRange: {
          startDate: dates.startDate,
          endDate: dates.endDate
        },
        timeRange: {
          startTime: { HH: '00', mm: '00' },
          endTime: { HH: '23', mm: '59' }
        },
        reportByProp: { id: 0 },
        direction: { id: 1 }
      };

      const apiCall = this.$isRegionalCenterBranch() ? GetCategoryGiroForDealer : GetCategoryGiro;
      apiCall(payload).then(res => {
        if (res && res.status == 200) {
          this.categoryGiroItems = res.data;
          this.totalCategoryPrice = res.data.reduce((acc, val) => acc + (val.amount || 0), 0);
          this.totalCategoryQuantity = res.data.reduce((acc, val) => acc + (val.piece || 0), 0);
        }
      }).catch(err => {
        console.error('Kategori ciro alınamadı:', err);
      });
    },
    fetchStaffActions() {
      const dates = this.getReportDates();
      let payload = {
        branch: this.getBranchPayload(),
        dateRange: {
          startDate: dates.startDate,
          endDate: dates.endDate
        }
      };

      GetStaffActionReport(payload).then(res => {
        if (res && res.status == 200 && res.data) {
          this.staffActions = res.data.items || [];
        }
      }).catch(err => {
        console.error('Personel işlem raporu alınamadı:', err);
      });
    },
    fetchLosses() {
      const dates = this.getReportDates();
      let payload = {
        branch: this.getBranchPayload(),
        dateRange: {
          startDate: dates.startDate,
          endDate: dates.endDate
        },
        timeRange: {
          startTime: { HH: '00', mm: '00' },
          endTime: { HH: '23', mm: '59' }
        },
        pageIndex: 0,
        pageSize: 1000
      };

      const apiCall = this.$isRegionalCenterBranch() ? getLossListForDealer : getLossList;
      apiCall(payload).then(res => {
        if (res && res.status == 200 && res.data) {
          this.totalLossAmount = res.data.totalPrice || 0;
        }
      }).catch(err => {
        console.error('Zayiatlar alınamadı:', err);
      });
    },
    fetchDiscounts() {
      const dates = this.getReportDates();
      let payload = {
        branch: this.getBranchPayload(),
        dateRange: {
          startDate: dates.startDate,
          endDate: dates.endDate
        },
        timeRange: {
          startTime: { HH: '00', mm: '00' },
          endTime: { HH: '23', mm: '59' }
        },
        pageIndex: 0,
        pageSize: 1000
      };

      const apiCall = this.$isRegionalCenterBranch() ? getDiscountListForDealer : getDiscountList;
      apiCall(payload).then(res => {
        if (res && res.status == 200 && res.data) {
          this.totalDiscountAmount = res.data.totalAmount || 0;
          this.totalDiscountCount = (res.data.page && res.data.page.totalCount) || 0;
        }
      }).catch(err => {
        console.error('İndirimler alınamadı:', err);
      });
    },
    fetchSalesTotals() {
      const dates = this.getReportDates();
      let payload = {
        branch: this.getBranchPayload(),
        dateRange: {
          startDate: dates.startDate,
          endDate: dates.endDate
        },
        timeRange: {
          startTime: { HH: '00', mm: '00' },
          endTime: { HH: '23', mm: '59' }
        }
      };

      const apiCall = this.$isRegionalCenterBranch() ? GetTotalsOfSalesForDealer : GetTotalsOfSales;
      apiCall(payload).then(res => {
        if (res && res.status == 200 && res.data) {
          this.totalSalesAmount = res.data.totalAmount || 0;
        }
      }).catch(err => {
        console.error('Satış toplamları alınamadı:', err);
      });

      const sumOfOrdersPayload = {
        branchId: payload.branch ? payload.branch.id : null,
        dateRange: payload.dateRange,
        timeRange: payload.timeRange
      };
      const sumOfOrdersApi = this.$isRegionalCenterBranch() ? getSumOfOrdersForDealer : getSumOfOrders;
      sumOfOrdersApi(sumOfOrdersPayload).then(sumRes => {
        if (sumRes && sumRes.status == 200 && sumRes.data && sumRes.data.paymentReport) {
          const positivePayments = sumRes.data.paymentReport.filter(x => x.effect === 'Pozitif');
          this.totalSalesCount = positivePayments.reduce((acc, curr) => acc + (curr.totalCount || 0), 0);
        }
      }).catch(err => {
        console.error('Sipariş toplam adetleri alınamadı:', err);
      });
    },
    fetchPaymentReport() {
      const dates = this.getReportDates();
      let payload = {
        branch: this.getBranchPayload(),
        dateRange: {
          startDate: dates.startDate,
          endDate: dates.endDate
        },
        timeRange: {
          startTime: { HH: '00', mm: '00' },
          endTime: { HH: '23', mm: '59' }
        }
      };

      const apiCall = this.$isRegionalCenterBranch() ? GetPaymentReportForDealer : GetPaymentReport;
      apiCall(payload).then(res => {
        if (res && res.status == 200 && res.data) {
          this.paymentReportItems = res.data;
        }
      }).catch(err => {
        console.error('Ödeme raporu alınamadı:', err);
      });
    },
    fetchProductGiro() {
      this.kuverCountFromProducts = 0;
      const dates = this.getReportDates();
      let payload = {
        branch: this.getBranchPayload(),
        dateRange: {
          startDate: dates.startDate,
          endDate: dates.endDate
        },
        timeRange: {
          startTime: { HH: '00', mm: '00' },
          endTime: { HH: '23', mm: '59' }
        }
      };

      const apiCall = this.$isRegionalCenterBranch() ? GetProductGiroForDealer : GetProductGiro;
      apiCall(payload).then(res => {
        if (res && res.status == 200 && res.data) {
          const kuverProduct = res.data.find(x => (x.typeValue || x.name || '').toLowerCase().includes('kuver'));
          if (kuverProduct) {
            this.kuverCountFromProducts = kuverProduct.piece || kuverProduct.quantity || 0;
          }
        }
      }).catch(err => {
        console.error('Ürün ciro raporu alınamadı:', err);
      });
    },
    printReport() {
      this.$nextTick(() => {
        const prtHtml = document.getElementById('zReportContent').innerHTML;
        let stylesHtml = '';
        for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
          stylesHtml += node.outerHTML;
        }
        const WinPrint = window.open('', '', 'left=0,top=0,width=400,height=900,toolbar=0,scrollbars=0,status=0');
        WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            ${stylesHtml}
            <style>
              body { margin: 0; padding: 10px; background: #fff; }
              .hide-on-print { display: none !important; }
            </style>
          </head>
          <body>
            ${prtHtml}
          </body>
        </html>`);
        WinPrint.document.close();
        window.setTimeout(() => {WinPrint.focus(); WinPrint.print(); WinPrint.close();}, 1000);
      });
    }
  }
}
</script>

<style scoped>
#zReportPopup .vs-popup {
  width: 450px !important;
  color: #000;
}
.z-report-slip {
  font-family: 'Courier New', Courier, monospace;
  font-size: 13px;
  background-color: #fcfcfc;
  padding: 10px 20px;
  max-width: 400px;
  margin: 0 auto;
  color: #000;
  border: 1px solid #ddd;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}
.z-logo {
  max-width: 120px;
  margin: 0 auto;
  filter: grayscale(100%);
}
.dashed-line {
  border-top: 1px dashed #000;
  margin: 8px 0;
}
.text-center { text-align: center; }
.text-left { text-align: left; }
.text-right { text-align: right; }
.mt-1 { margin-top: 5px; }
.mt-2 { margin-top: 10px; }
.mt-4 { margin-top: 20px; }
.bold { font-weight: bold; }

.header-info, .z-section {
  width: 100%;
}
.info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2px;
}
.section-title {
  text-align: center;
  font-weight: bold;
  margin: 10px 0;
}
.z-table {
  width: 100%;
  border-collapse: collapse;
}
.z-table th, .z-table td {
  padding: 3px 0;
  vertical-align: top;
}
.z-footer h3 {
  font-size: 16px;
  margin: 15px 0 5px;
}
</style>
